import { Accordion, AccordionDetails, AccordionSummary, alpha, Box, Button, styled } from '@mui/material';

export const TestCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: '14px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
}));

export const TestActionBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const RunButton = styled(Button)(({ theme }) => ({
  borderRadius: '9px',
  fontWeight: 700,
  letterSpacing: '0.03em',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': { backgroundColor: theme.palette.primary.dark },
  '&.Mui-disabled': { backgroundColor: alpha(theme.palette.primary.main, 0.3), color: alpha('#fff', 0.5) },
}));

export const ResultPanel = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.75),
  borderRadius: '10px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
}));

export const TestAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  backgroundImage: 'none',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '10px',
  boxShadow: 'none',
  overflow: 'hidden',
  '&:before': { display: 'none' },
  '&.Mui-expanded': { margin: 0 },
  '&:first-of-type': { borderTopLeftRadius: '10px', borderTopRightRadius: '10px' },
  '&:last-of-type': { borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' },
}));

export const TestAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: 46,
  padding: theme.spacing(0, 1.75),
  '& .MuiAccordionSummary-content': { margin: theme.spacing(1.25, 0) },
  '&.Mui-expanded': { minHeight: 46 },
  '& .MuiAccordionSummary-expandIconWrapper': { color: theme.palette.info.main },
  '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.06) },
}));

export const TestAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0, 1.75, 1.75),
  borderTop: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(1.5),
}));

export const RunRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0.75, 1),
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
}));
